import api from './api';

export const getMeters = async () => (await api.get('/water/meters')).data;
export const createMeter = async (data) => (await api.post('/water/meters', data)).data;
export const updateMeter = async (id, data) => (await api.put(`/water/meters/${id}`, data)).data;
export const deleteMeter = async (id) => (await api.delete(`/water/meters/${id}`)).data;

export const getApiToken = async () => (await api.get('/water/api-token')).data;
export const regenerateApiToken = async () => (await api.post('/water/api-token')).data;

export const getReadings = async (params = {}) => (await api.get('/water/readings', { params })).data;
